<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 21">
    <path d="M6,11.2v-1.5h8v1.5H6Z" />
  </svg>
</template>
